import { AutogenModelCustomModelDefinition, AutogenRowCustomModelDefinition } from "./autogen/AutogenModelCustomModelDefinition";

export class ModelCustomModelDefinition extends AutogenModelCustomModelDefinition<RowCustomModelDefinition> {
	constructor() {
		super(RowCustomModelDefinition);
	}
}

export class RowCustomModelDefinition extends AutogenRowCustomModelDefinition {
}